import { memo } from 'react';
import { Link } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import NotificationBell from '../../../components/NotificationBell';

const NotificationButton = () => {
	const classes = useStyles();

	return (
		<Button
			component={Link}
			to="/notificações"
			endIcon={<NotificationBell className={classes.bell} />}
			className={classes.button}
		>
			Notificações
		</Button>
	);
}

export default memo(NotificationButton);

const useStyles = makeStyles<Theme>((theme) =>
	createStyles({
		bell: {
			width: theme.spacing(4),
			height: theme.spacing(4),

			'&&': {
				'& img': {
					objectFit: 'contain',
					maxHeight: 18,
				}
			}
		},
		button: {
			minWidth: 140,
			padding: theme.spacing(0.5, 1.8),
			color: theme.palette.primary.contrastText,
			fontWeight: theme.typography.fontWeightBold,
			textTransform: 'initial',

			border: `1px solid ${theme.palette.secondary.main}`,
			borderRadius: 15,
			background: 'linear-gradient(180deg, #FFC107 0%, #FF9E18 100%)',
			justifyContent: 'flex-start',
			position: 'relative',

			'& .MuiButton-endIcon': {
				position: 'absolute',
				right: 0,
			}
		},
	})
);
